export const SUPPORT_WIDGET_LOCAL_STORAGE_KEY = "support-widget-v2-state";

export const WIDGET_HIDDEN_ROUTES = [
  "/messages/new",
  "/messages",
  "/live",
  "/workflows/edit",
  "/workflows/new",
  "/workflows/view",
  "/discover",
  "/settings/branded_apps_builder_ui",
  "/settings/pages/edit",
] as const;

export const SUPPORT_WIDGET_DEFAULT_TRANSITIONS = {
  enter: "transition ease-out duration-200 transform",
  enterFrom: "opacity-0 scale-95",
  enterTo: "opacity-100 scale-100",
  leave: "transition ease-in duration-200 transform",
  leaveFrom: "opacity-100 scale-100",
  leaveTo: "opacity-0 scale-95",
} as const;
